import React, {useEffect, useState} from 'react'

export default function Personne(props) {
    const {picture, name, fonction, phone, mail, left, right, index} = props
    const [opacity, setOpacity] = useState(0)
    const [positionLeft, setPositionLeft] = useState(left ? left : 0)
    const [positionRight, setPositionRight] = useState(right ? right : 0)
    useEffect(() => {
        setOpacity(1)
        setTimeout(() => {
            setPositionRight(0)
            setPositionLeft(0)
        }, index * 50)
    }, [])
    return (
        <div className='personne flex alignStart between' style={{left : left && positionLeft, right : right && positionRight, opacity : opacity}} >
            <div className='centerImg'>
                <img src={`/trombinoscope/${picture}`} alt="photo" />
            </div>
            <div>
                <p className="name">{name}</p>
                <p className="fonction">{fonction}</p>
                <p className="phone">{phone}</p>
                <p className="mail">{mail}</p>
            </div>
        </div>
    )
}
